import Vue from 'vue'
import Router from 'vue-router'
import index from '@/page/index'
// import login from '@/page/login'
// import mainPage from '@/page/home/mainPage'
// import myInfo from '@/page/setting/myInfo'
// import userList from '@/page/matching/userList'
// import history from '@/page/matching/history'
// import myAll from '@/page/setting/myAll'
// import userInfo from '@/page/matching/userInfo'
// import chatting from '@/page/chat/chatting'


Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      component: () => import('@/page/home/mainPage')
    }, { 
      path: '/login',
      component: () => import('@/page/login')
    },
    {
      path: '/home/mainPage',
      component: () => import('@/page/home/mainPage'),
      meta:{
        keepAlive:true
      },
      children:[
        {
          path: 'userList',
          component: () => import('@/page/matching/userList'),
          meta:{
            keepAlive:true
          },
        },{
          path: 'history',
          component: () => import('@/page/matching/history'),
        },{
          path: 'myAll',
          component: () => import('@/page/setting/myAll'),
        },
        {
          path: 'userInfo/:id',
          component: () => import('@/page/matching/userInfo'),
        },
        {
          path: 'chatting/:id',
          component:  () => import('@/page/chat/chatting'),
        },
        {
          path: 'seeLogList',
          component:  () => import('@/page/matching/seeLogList'),
        },
      ],
    }, {
      path: '/setting/myInfo',
      component: () => import('@/page/setting/myInfo'),
    },
    
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js